import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import * as saveAs from 'file-saver';
import { mongoId } from '../../../../../@core/common/global';
import { ApiService } from '../../../../../@core/service/api.service';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { CompilationModel, EPackingStatus } from '../../../../../@models/erp/compilation';
import { AvailabilityStatusData, CompilationTypeData, IssuerData, SpoStatusData, TransportStatusData } from '../../../../../@models/erp/compilationData';
import { FinishedProductModel } from '../../../../../@models/erp/finishedProduct';
import { LineItemModel } from '../../../../../@models/erp/lineItem';
import { DownloadConfig } from '../../document-printer/document-printer.component';
import { ContactModel, EBusinessType, EContactType } from '../../../../../@models';
import { PfspoChartsComponent } from './pfspo-charts/pfspo-charts.component';

export enum PfspoSelectorMode {
  popup = 1,
  list = 2,
  pdf = 3,
  newline = 4,
}

@Component({
  selector: 'ngx-line-item-pfspo-selector',
  templateUrl: './line-item-pfspo-selector.component.html',
  styleUrls: ['./line-item-pfspo-selector.component.scss'],
})
export class LineItemPfspoSelectorComponent implements OnInit, OnChanges {
  @Input() compilation: CompilationModel;
  @Input() lineItem: LineItemModel;
  @Input() disabled: boolean = false;
  @Input() hideStats: boolean = false;
  @Input() pfspoData: any[];
  @Input() print = false;
  @Input() dialog = true;
  @Input() mode: PfspoSelectorMode = PfspoSelectorMode.popup;
  @Output() recalc: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() dataChanged: EventEmitter<any> = new EventEmitter<any>();

  // @ViewChild(NbPopoverDirective, { static: false }) popover: NbPopoverDirective;
  @ViewChildren(PfspoChartsComponent) pfspoCharts:  QueryList<PfspoChartsComponent>;

  columnOptions = [
    { id: 'parentPos',        name: 'OC',           search: '', type: 'number', style: { 'text-align': 'center' } },
    { id: 'code',             name: '(PF)SPO #',        search: '' },
    { id: 'pos',              name: 'SPO',          search: '', type: 'number', style: { 'text-align': 'center' } },
    { id: 'combinedShipment', name: 'GS',          search: '', type: 'number', style: { 'text-align': 'center' } },
    { id: 'customerReference',name: 'Customer name',    search: '' },
    { id: 'fpCode',           name: 'Prod code',        search: '' },
    { id: 'fpName',           name: 'Product',          search: '' },
    { id: 'fpDimensions',     name: 'Dimensions',       search: '' },
    { id: 'externalCode',     name: 'Customer product code',       search: '' },
    // { id: 'unit',             name: 'Unit',             search: '', style: { 'text-align': 'center' } },
    { id: 'exwDate',          name: 'EXW date',         search: '' },
    { id: 'vieArrivalDate',   name: 'VIE arrival date', search: '' },
    { id: 'spoStatus',        name: 'PFSPO status',     search: '' },
    { id: 'transportStatus',  name: 'Transport status', search: '' },
    { id: 'availabilityStatus', name: 'Availability status', search: 'Not completed' },
    { id: 'quantity',         name: 'Quantity',         search: '', type: 'number', style: { 'text-align': 'right' }, m2: 0 },
    // { id: 'plannedQuantity',  name: 'ASSQ', search: '', type: 'number', mode: 0, editable: false }, // mode: PfspoSelectorMode.list, editable: false },
    { id: 'deliveredQ', name: 'DELQ', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 0 },
    { id: 'availableQ', name: 'AVBLQ', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 0 },
    { id: 'assignedQ', name: 'ASSQ', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 0 },
    { id: 'freeQ', name: 'FREEQ', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 0 },
    // { id: 'text',           name: 'Text',             search: '', mode: 0, editable: false }, // mode: PfspoSelectorMode.newline, editable: true },
    { id: 'm2quantity',         name: 'Quantity m²',         search: '', type: 'number', style: { 'text-align': 'right' }, m2: 1 },
    // { id: 'plannedQuantity',  name: 'ASSQ', search: '', type: 'number', mode: 0, editable: false }, // mode: PfspoSelectorMode.list, editable: false },
    { id: 'm2deliveredQ', name: 'DELQ m²', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 1 },
    { id: 'm2availableQ', name: 'AVBLQ m²', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 1 },
    { id: 'm2assignedQ', name: 'ASSQ m²', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 1 },
    { id: 'm2freeQ', name: 'FREEQ m²', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 1 },
    { id: 'mquantity',         name: 'Quantity m',         search: '', type: 'number', style: { 'text-align': 'right' }, m2: 2 },
    { id: 'mdeliveredQ', name: 'DELQ m', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 2 },
    { id: 'mavailableQ', name: 'AVBLQ m', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 2 },
    { id: 'massignedQ', name: 'ASSQ m', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 2 },
    { id: 'mfreeQ', name: 'FREEQ m', search: '', type: 'number', style: { 'text-align': 'right' }, m2: 2 },
  ]

  sort: { col: string, dir: number } = { col: 'vieArrivalDate', dir: -1 };

  pfspoLineData: any[];

  filteredSpos: any[];

  issuer: string;

  showAssignedPFSPOs = false;

  spoMode = PfspoSelectorMode;
  issuerData = IssuerData;

  availabilityStatus = 1;

  businessIdFilter: string = '';
  finishedProductsFilter = [];
  finishedProductOptions = [];

  // showNotComplete = true;
  // showComplete = false;

  selectedSpo = null;

  page: number = 0;

  cacheRefreshing = false;
  // stockNrka = false;
  // stockNrkaEnRoute = false;
  // stockNrkaPlanned = false;
  recipient = null;
  recipientOptions = [];

  // combinedShipment = null;
  // combinedShipmentOptions = [];

  transportFilter = {
    stockNrka: true,
    enRoute: false,
    planned: false,
  }

  accountManager: string;
  employeeOptions: { id: string, name: string } [] = [];

  businessUnit: string = 'EM';
  businessUnitOptions: { id: string, name: string } [] = [];

  showSqm = 0;

  constructor(private api: ApiService, public data: SharedDataService, private decimalPipe: DecimalPipe) { }

  async ngOnInit(): Promise<void> {

    // TODO: integrate pfspoData with document tree

    if (this.pfspoData && this.mode > 1) {
      this.pfspoLineData = this.pfspoData;
    } else {
      if (this.lineItem && this.lineItem.finishedProduct) {
        this.pfspoLineData = await this.api.getSpoData(this.lineItem.finishedProduct.calcCode);
        // this.columnOptions.find(f => f.id === 'fpCode').search = this.lineItem.finishedProduct.calcCode;
        this.finishedProductsFilter = [this.lineItem.finishedProduct.calcCode];
        window.setTimeout(async () => {
          this.pfspoLineData = await this.api.getSpoData()
        }, 500)
      } else {
        this.pfspoLineData = await this.api.getSpoData();
      }
    }
    this.issuer = this.compilation && IssuerData.get(this.compilation.issuer).name.toLowerCase();
    // this.data.loadBusinesses().then(() => this.recipientOptions = this.data.businessOptions);
    // this.combinedShipmentOptions = (await this.api.getCombinedShipments()).map(m => ({ id: m.code, name: m.code })).reverse();

    // await this.data.loadBusinesses();
    // this.recipientOptions = this.data.businessOptions;
    // const contacts = await lastValueFrom(this.api.reloadContacts({type: EBusinessType.NRK, contactType: EContactType.Employee}))
    // // await this.data.loadBusinesses();
    // // this.data.business.nrka.contacts.filter(f => f.type === EContactType.Employee).map(m => m._id);
    // // this.employeeOptions = this.data.contactOptions.filter(f => employees.includes(f.id));
    // this.employeeOptions = contacts.map(m => ({id: m._id, name: m.displayTitle}));

    await Promise.all([this.data.loadContacts(), this.data.loadBusinesses()]);
    this.recipientOptions = this.data.businessOptions
    // const employees = this.data.business.nrka.contacts.filter(f => f.type === EContactType.Employee).map(m => m._id);
    this.employeeOptions = this.data.contacts.filter(f => f.business?.type === EBusinessType.NRK && f.type === EContactType.Employee).map(m => ({id: m._id, name: m.displayTitle}))
    this.businessUnitOptions = [{id: 'all', name: 'All'}, ...Array.from(new Set(this.pfspoLineData.map(m => m.fpCode.replace(/-.*/,'')))).map(m => ({id: m, name: m}))]
    // console.log('bu options', this.businessUnitOptions, this.pfspoLineData.map(m => m.fpCode.replace(/-.*/,'')))
    this.finishedProductOptions = Array.from(new Set(this.pfspoLineData.map(m => m.fpCode))).map(m => ({id: m, name: this.data.finishedProducts.find(f => f.calcCode === m)?.calcName}))


    this.presort();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.pfspoData) {
      this.pfspoLineData = this.pfspoData;
      this.filter();
    } else if (changes.compilation?.currentValue) {
      this.businessIdFilter = mongoId(this.compilation?.recipient);
    }
  }

  // get availbilityStatus() {
  //   return this.columnOptions.find(f => f.id === 'availabilityStatus').search;
  // }
  // set availabilityStatus(status: string) {
  //   this.columnOptions.find(f => f.id === 'availabilityStatus').search = status;
  //   this.filter();
  // }

  presort() {
    this.filteredSpos = this.pfspoLineData?.filter(f => {
      return !f.draft 
      && (!this.finishedProductsFilter?.length || this.finishedProductsFilter.includes(f.fpCode))
      && (this.availabilityStatus === null || this.availabilityStatus === f.availabilityStatus)
      && (!this.accountManager?.length || this.accountManager === f.salesManager)
      && (this.businessUnit === 'all' || f.fpCode.startsWith(this.businessUnit))
      // && ((!this.transportFilter.stockNrka
      //   || (f.spoStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('completed').id)
      // )
      // && (!this.transportFilter.enRoute
      //   || (this.transportFilter.enRoute && f.spoStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('enRoute').id)
      // )
      // && (!this.transportFilter.planned
      //   || (this.transportFilter.planned && f.spoStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('planned').id)
      // ))
      && ((!this.transportFilter.stockNrka && !this.transportFilter.enRoute && !this.transportFilter.planned)
        || (this.transportFilter.stockNrka && f.availabilityStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('completed').id)
        || (this.transportFilter.enRoute && f.availabilityStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('enRoute').id)
        || (this.transportFilter.planned && f.availabilityStatus === AvailabilityStatusData.get('notCompleted').id && f.transportStatus === TransportStatusData.get('planned').id)
      )
      && (!this.recipient || (f.customerReference === this.recipient))
      // && (!this.combinedShipment || (f.combinedShipment == this.combinedShipment))
    })
    // this.filteredSpos = this.filteredSpos.sort((a, b) => a.vieArrivalDate > b.vieArrivalDate ? 1 : -1) // sort by arrival date (for freeQ == 0)
    //   .sort((a, b) => a.freeQ ? -1: 1) // separate freeQ > 0 from freeQ == 0
    //   .sort((a, b) => a.freeQ ? (a.vieArrivalDate > b.vieArrivalDate ? 1 : -1) : 0) // if freeQ > 0 sort by arrival date
    // // console.log('==>presort end');
    this.filter(this.filteredSpos)
  }

  filter(data: any = null) {

    if (!data) data = this.pfspoLineData;
    if (!data) return;
    for (const col of this.columnOptions) {
      if (col.search && col.search.length) data = data.filter(f => {
        const cmp = '' + this.getText(f, col); // f[col.id];
        return cmp.toLowerCase().includes(col.search.toLowerCase())
      })
    }
    // this.filteredSpos = this.showAssignedPFSPOs ? data.filter(f => !f.draft) : data.filter(f => !f.draft && (!f.relatedOCs || !f.relatedOCs.length));
    // if (this.showAssignedPFSPOs) {
    //   this.filteredSpos = data.filter(f => !f.draft);
    // } else {
    //   this.filteredSpos = data.filter(f => !f.draft && (!f.relatedOCs || !f.relatedOCs.length));
    // }
    // console.log('data, data', this.showComplete, this.showNotComplete, data);
    
    // if (this.showNotComplete && !this.showComplete) {
    //   this.filteredSpos = data.filter(f => !f.draft && f.availabilityStatus !== AvailabilityStatusData.get('completed').id);
    // } else if (this.showComplete && !this.showNotComplete) {
    //   this.filteredSpos = data.filter(f => !f.draft && f.availabilityStatus === AvailabilityStatusData.get('completed').id);
    // } else {
    //   this.filteredSpos = data.filter(f => !f.draft);
    // }
    this.filteredSpos = data.filter(f => 
      !f.draft 
      && (!this.finishedProductsFilter?.length || this.finishedProductsFilter.includes(f.fpCode))
      && (this.availabilityStatus === null || this.availabilityStatus === f.availabilityStatus)
    );

    if (this.sort.col) this.filteredSpos = this.filteredSpos.sort((a, b) => {
      const numeric = this.columnOptions.find(f => f.id === this.sort.col)?.type === 'number';
      let texta = this.getText(a, { id: this.sort.col });
      let textb = this.getText(b, { id: this.sort.col });
      if (numeric) {
        texta = texta ?? 0;
        textb = textb ?? 0;
        if (+texta === +textb) return 0;
        return +texta > +textb ? this.sort.dir : -this.sort.dir
      } else {
        texta = texta ?? '';
        textb = textb ?? '';
        if (texta === textb) return 0
        return (''+texta).localeCompare(''+textb) > 0 ? this.sort.dir : -this.sort.dir
      }
    });
    // console.log('===>filter end');

  }

  onSort(col) {
    if (this.sort.col === col.id) {
      this.sort.dir = -this.sort.dir;
    } else {
      this.sort.col = col.id;
      this.sort.dir = -1;
    }
    this.filter(this.filteredSpos);
  }

  clearFilter(columnsOnly = false) {
    if (columnsOnly)
    {
      for (const col of this.columnOptions) {
        col.search = '';
      }
    } else {
    // // this.businessIdFilter = '';
    // if (!columnsOnly) {
      this.finishedProductsFilter = [];
      this.transportFilter.stockNrka = false;
      this.transportFilter.enRoute = false;
      this.transportFilter.planned = false;
      this.recipient = null;
      this.accountManager = null;
      this.businessUnit = 'all';
    }
    this.presort();
  }

  getText(spo, col) {
    if (col.id === 'code') {
      const code = spo['code'] + 'VS' + spo['version'];
      const name = spo['nameOverride'] && spo['nameOverride'] + '↴ ';
      return name ? name + code : code;
    }
    switch (col.id) {
      case 'code':
        const code = spo['code'] + 'VS' + spo['version'];
        const name = spo['nameOverride'] && spo['nameOverride'] + '↴ ';
        return name ? name + code : code;
      case 'spoStatus':
        return ['Unconfirmed', 'Confirmed', 'Completed', 'Exception'][spo[col.id]]; // SpoStatusData.get(spo[col.id])?.name ?? '';
      case 'transportStatus':
        return TransportStatusData.get(spo[col.id])?.name ?? '';
      case 'availabilityStatus':
        return ['', 'Not completed', 'Completed '][spo[col.id]]; // AvailabilityStatusData.get(spo[col.id])?.name ?? '';
      case 'customerReference':
        return this.data.businesses.find(f => mongoId(f) === mongoId(spo[col.id]))?.name || '';
    }
    return spo[col.id] || '';
  }

  save(spo: any) {
    // this.recalc.emit();
    this.selectedSpo = spo;
    if (!this.disabled) this.close.emit(spo);
  }

  availabilitySum(col: string) {
    switch (col) {
      case 'availableQ':
      case 'assignedQ':
      case 'freeQ':
        return 'Σ ' + this.filteredSpos?.reduce((a, c) => a + (c[col] || 0), 0) || 0;
      case 'm2availableQ':
      case 'm2assignedQ':
      case 'm2freeQ':
      case 'mavailableQ':
      case 'massignedQ':
      case 'mfreeQ':
        return 'Σ ' + Math.round(this.filteredSpos?.reduce((a, c) => a + (c[col] || 0), 0) || 0);
    }
  }

  finishedProductsChanged(products: FinishedProductModel[]) {
    // console.log('finishedProductsChanged', products);
    this.finishedProductsFilter = products.map(m => m.calcCode);
    this.filter();
    this.presort();
  }

  async refreshData() {
    this.cacheRefreshing = true;
    await this.api.refreshCache();
    // await this.ngOnInit();
    this.pfspoLineData = await this.api.getSpoData()
    this.cacheRefreshing = false;
  }

  colors = {
    unconfirmed: '#ff9988',
    confirmedPlanned: '#ffcc77',
    confirmedEnRoute: '#ffff88',
    fullyOnStock: '#77dd77',
    partiallyAvailable: '#99ff99',
    fullQAssigned: '#aaccff',
    completelyDelivered: '#dddddd',
    exception: '#ffaaff',
  }
  
  getStyle(doc, withSelected = false) {
    // return spo === this.selectedSpo ? { 'background-color': '#fb1'} : (spo.freeQ > 0 ? { 'background-color': '#bfb' } : null)
    let bgColor = '#E5F0F5';
    const [unconfirmed, confirmed] = [0, 1]; // ['Unconfirmed', 'Confirmed']; // spo status
    const [planned, enRoute, completed] = [1, 2, 3]; // ['Planned', 'En route', 'Completed']; // transport status
    const [noCompleted, yesCompleted] = [1, 2] // ['Not completed', 'Completed ']; // availability status

    if (doc.spoStatus === SpoStatusData.get('exception').id) {
      bgColor = this.colors.exception;
    } else if (doc.spoStatus === unconfirmed ) {
      bgColor = this.colors.unconfirmed;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === planned && doc.availabilityStatus === noCompleted) {
      bgColor = this.colors.confirmedPlanned;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === enRoute && doc.availabilityStatus === noCompleted) {
      bgColor = this.colors.confirmedEnRoute;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === completed && doc.availabilityStatus === noCompleted && doc.freeQ === doc.quantity) {
      bgColor = this.colors.fullyOnStock;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === completed && doc.availabilityStatus === noCompleted && doc.freeQ > 0 ) {
      bgColor = this.colors.partiallyAvailable;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === completed && doc.availabilityStatus === noCompleted && doc.freeQ === 0 && doc.assignedQ > 0) {
      bgColor = this.colors.fullQAssigned;
    } else if (doc.spoStatus === confirmed && doc.transportStatus === completed && doc.availabilityStatus === yesCompleted) {
      bgColor = this.colors.completelyDelivered;
    }

    if (doc === this.selectedSpo && withSelected) {
      bgColor = '#fb1';
    }

    return { 'background-color': bgColor }
  }

  async downloadXlsx() {

    const config = new DownloadConfig;

    // filter hidden columns
    const data = {
      header: this.columnOptions.map(m => ({ name: m.id, header: m.name })),
      table: this.filteredSpos.map(r => this.columnOptions.map(c => this.getText(r, c))),
    }

    config.table = JSON.stringify(data);

    await this.data.loadContacts();

    const manager = this.accountManager ? '_' + this.data.contacts.find(f => f._id === this.accountManager)?.title.split(' ')?.pop() : ''
    const customer = this.recipient ? '_' + this.recipientOptions.find(f => f.id === this.recipient)?.name : ''

    this.api.getDocumentFile('/api/v1/document_report/xls', config).subscribe(async res => {
      saveAs(res, (new Date()).toISOString().replace(/\d\d(\d\d)-(\d\d)-(\d\d)T.*/, '$1$2$3') + `${customer}_PFSPO_Availability${manager}.xlsx`);
    });

  }

  downloadTimeline() {
    const config = new DownloadConfig;

    const spos = this.filteredSpos;
    const products = Array.from(new Set(this.filteredSpos.map(m => m.fpCode)));

    // table headers
    const data = {
      header: [],
      table: [
        ['', '(PF)SPO', ...spos.map(m => m.code), ''],
        ['', 'CS', ...spos.map(m => m.combinedShipment), ''],
        ['', 'EXW Date', ...spos.map(m => m.exwDate), ''],
        ['', 'VIE Arrival', ...spos.map(m => m.vieArrivalDate), ''],
        ['Product', 'Dimension', ...spos.map(m => ''), 'Total'],
      ]
    }

    // group by broduct x SPO
    products.forEach(prod => {
      const docs = spos.filter(f => f.fpCode === prod);
      data.table.push([
        docs[0].fpName,
        docs[0].fpDimensions,
        ...spos.map(m => m.fpCode === prod ? m.quantity : null),
        spos.reduce((a, c) => a + (c.fpCode === prod ? c.quantity : 0), 0)
      ])
    })

    // add totals for each column, omit ascii cells (idx > 1, colidx > 4)
    data.table.push(
      data.table[0].map(
        (m, idx) => idx > 1 
        ? data.table.reduce((a, c, colidx) => 
          colidx > 4 ? a + (c[idx] || 0) : 0
          , 0
        ) 
        : ''
      )
    )
    data.table[data.table.length-1][1] = 'Total Result'

    config.table = JSON.stringify(data);

    this.api.getDocumentFile('/api/v1/document_report/xls', config).subscribe(async res => {
      saveAs(res, (new Date()).toISOString().replace(/\d\d(\d\d)-(\d\d)-(\d\d)T.*/, '$1$2$3') + '_PFSPO_Timeline.xlsx');
    });

  }

  openPfspoChartWin(spo: any, idx: number) {
    console.log('openPfspoChartWin', this.pfspoCharts, spo, idx);
    this.pfspoCharts.get(idx).pfspoChartWin.open();
    this.pfspoCharts.get(idx).rebuildCharts();
  }

}
